import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QRCode from 'qrcode';

import i18next from 'i18next'

import { setVtcoTwoFactorCode } from '../../actions/localStates'

class VTokenPassConfirmPopup extends Component {

  constructor(props) {
      super(props);
      this.state = {
          qrCode: '',
          secondsLeft: this.props.mpoTtlMillis - 1
      };
      
      this.onTwoFactorCodeChanged = this.onTwoFactorCodeChanged.bind(this);

      this.handle2FKeyUp = this.handle2FKeyUp.bind(this, 'twoFactorInput');
      this.closePopup = this.closePopup.bind(this);
      this.closePopupCancel = this.closePopupCancel.bind(this);
  }

  componentDidMount() {
      this.props.actions.setVtcoTwoFactorCode("");
      var element = document.getElementById("2f");

      if (element !== null) {
        element.focus();
      }

      QRCode.toDataURL(this.props.image)
      .then((url) => {
            this.setState({ qrCode: url });
      });
      
      document.addEventListener('keyup', this.handle2FKeyUp);

      this.timer = setInterval(() => {
          this.setState(prev => {
              if (prev.secondsLeft <= 1) {
                  clearInterval(this.timer);
                  this.props.cancelRequest()
                  return { secondsLeft: 0 };
              }

              return {
                  secondsLeft: prev.secondsLeft - 1
              };
          });
      }, 1000);
  }

  componentWillUnmount() {
      document.removeEventListener('keyup', this.handle2FKeyUp);
      if (this.timer) {
          clearInterval(this.timer);
      }
  }

  handle2FKeyUp(refName, e) {
      if (e.keyCode === 13 && refName === "twoFactorInput") {
          document.getElementById("submitPin").click();
          document.activeElement.blur();
      }
  }

  closePopup () {
    this.props.initAction(this.props.id)
  }

  closePopupCancel () {
    this.props.initAction(true)
    // this.props.actions.setNeed2fConfirm(false);
  }

  onTwoFactorCodeChanged (e) {
    this.props.actions.setVtcoTwoFactorCode(e.target.value)
  }

  cancelLogin2f () {
    this.props.cancelRequest()
    // this.props.initAction(true)
  }

  render() {
    let isEnabled = this.props.login.vtcoTwoFactorCode.length >= 6
    ? true
    : false

    let title = this.props.title;

    // if (this.props.image !== null) {
    //   const qr = this.props.image.trim();
    //   var qrToShow;
    //       qrToShow = qr.startsWith("data:")
    //           ? qr
    //           : `data:image/png;base64,${qr}`
    // }

      const TOTAL_SECONDS = this.props.mpoTtlMillis;

      const radius = 24;
      const circumference = 2 * Math.PI * radius;

      const progress = this.state.secondsLeft / TOTAL_SECONDS;

      const dashOffset = circumference * (progress - 1);

      return (
          <div className='popup'>
              <div className="popup_inner_2f">
                <div className="card">
                  <div className="card-header">
                      {i18next.t(title)}
                  </div>
                  <div className="card-body" style={{padding: "1.5rem"}}>
                    <div>
                        <div style={{textAlign: "center"}}>
                            <img src={this.state.qrCode} style={{
                                  width: "256px",
                                  height: "256px",
                                  display: "block",
                                  margin: "0 auto"
                              }} alt="img" />
                        <label style={{fontSize: "14px"}}>{i18next.t("scanVTokenPassQr")}</label>
                        <p></p>
                        <button id="submit2f" className="btn btn-default" style={{float: "right"}} onClick={this.cancelLogin2f.bind(this)}>{i18next.t("cancelLabel")}</button>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div
                    style={{
                        position: "absolute",
                        left: "15px",
                        bottom: "15px"
                    }}
                    >
                    <svg width="60" height="60">
                        <circle
                            cx="30"
                            cy="30"
                            r={radius}
                            fill="none"
                            stroke="#ddd"
                            strokeWidth="4"
                        />

                        <circle
                            cx="30"
                            cy="30"
                            r={radius}
                            fill="none"
                            stroke="rgb(17, 45, 106)"
                            strokeWidth="4"
                            strokeLinecap="round"
                            transform="rotate(-90 30 30)"
                            strokeDasharray={circumference}
                            strokeDashoffset={dashOffset}
                            style={{
                                transition: "stroke-dashoffset 0.1s linear"
                            }}
                        />

                        <text
                            x="30"
                            y="35"
                            textAnchor="middle"
                            fontSize="16"
                            fontWeight="bold"
                        >
                            {this.state.secondsLeft}
                        </text>
                    </svg>
                </div>
            </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        base: state.base,
        pkLocalState: state.privateKeyReducer,
        login: state.privateKeyReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      setVtcoTwoFactorCode
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VTokenPassConfirmPopup);